import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faImage, faMapMarked, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

//Helpers
import { showMessage } from '../../helpers/message';
import mascaras from '../../helpers/mascaras';

//Context
import { useAuth } from '../../context/auth';

//Components
import MainCard from '../../components/MainCard/MainCard';
import CustomizedMap from '../../components/CustomizedMap/CustomizedMap';

//API
import autoInfracao_api from '../../api/autoInfracao_api';

export default function AutoDeInfracaoImpressao({ hash: hashProp, handleReturn }) {
  const location = useLocation();
  const { setLoading, setupVariavel, session } = useAuth();

  const [hash, setHash] = useState("");
  const [impressaoAutoInfracao, setImpressaoAutoInfracao] = useState(null);
  const refRelatorio = useRef();

  const handlePrint = useReactToPrint({
    content: () => refRelatorio.current,
    copyStyles: true,
    documentTitle: `Auto de infração - ${hash}`,
  });

  async function loadImpressaoAutoInfracao(inputHash) {
    if (!inputHash) {
      showMessage("Aviso", "É necessário um hash válido!", "warning", null);
      return;
    }

    setLoading(true);
    try {
      const { data } = await autoInfracao_api.GetImpressaoAutoInfracao(inputHash);
      setImpressaoAutoInfracao(data);
      setHash(inputHash);
    } catch (error) {
      showMessage("Erro", error.message || "Erro ao buscar dados", "error", null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const hashFromQuery = searchParams.get("hash");

    const finalHash = hashProp || hashFromQuery;
    loadImpressaoAutoInfracao(finalHash);
  }, [location, hashProp]);

  return (
    <MainCard btnVoltarInTop={session ? handleReturn : null}  btnImprimir={handlePrint}>
            
        <div className="mt-4 relatorio w-100" ref={refRelatorio} style={{ color: "#666" }}>
            <div className='m-2' style={{ color: "#666" }} >
                <div className='d-flex justify-content-center align-items-center '>
                    <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%' }} />
                </div>
                <div className="d-flex gap-3">
                    <p><span className="fw-bold">Auto de infração: </span> {impressaoAutoInfracao?.autoInfracao_Id}</p>
                    <p><span className="fw-bold">Notificação: </span> {impressaoAutoInfracao?.notificacao_Id}</p>
                    <p><span className="fw-bold">Agente: </span> {impressaoAutoInfracao?.agente}</p>
                </div>
            </div> 

            <div className="body">
                <div className="py-2 mb-2">
                    <h5
                        style={{ color: "#fff" }}
                        className='p-2 rounded-3 bg-gradient bg-primary d-flex justify-content-between align-items-center'
                    >
                        <span><FontAwesomeIcon icon={faFileAlt} className={"me-3"} />Dados da Infração</span>
                    </h5>
                    <div className="row">
                        <div className='col-lg-6'>
                            <p>
                                <span className="fw-bold">Data/Hora: </span>
                                {impressaoAutoInfracao?.dataHora ?? ""}
                            </p>
                        </div> 
                        <div className='col-lg-6'>
                            <p>
                                <span className="fw-bold">Local da infração: </span>
                                {`${
                                impressaoAutoInfracao?.enderecoAutoInfracao?.logradouro ?? ","
                                }, ${
                                impressaoAutoInfracao?.enderecoAutoInfracao?.bairro ?? "-"
                                } - ${
                                impressaoAutoInfracao?.enderecoAutoInfracao?.cidade ?? ""
                                }, ${impressaoAutoInfracao?.enderecoAutoInfracao?.numero ?? ""}.`}
                            </p>
                        </div> 
                    </div>
                </div>

                <div className="py-2 mb-2">
                    <h5
                        style={{ color: "#fff" }}
                        className='p-2 rounded-3 bg-gradient bg-primary d-flex justify-content-between align-items-center'
                    >
                        <span><FontAwesomeIcon icon={faFileAlt} className={"me-3"} />Dados do Infrator</span>
                    </h5>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <p>
                                <span className="fw-bold">
                                Nome do Infrator ou Responsável técnico proprietário:{" "}
                                </span>
                                {impressaoAutoInfracao?.infrator_Nome ?? ""}
                            </p>
                        </div>
                        <div className='col-lg-12'>
                            <p>
                                <span className="fw-bold">CPF/CNPJ: </span>
                                {impressaoAutoInfracao?.infrator_CpfCnpj
                                ? mascaras.cpfcnpjMask(impressaoAutoInfracao?.infrator_CpfCnpj)
                                : ""}
                            </p>
                        </div>

                       <div className='col-12'>
                            <p>
                                <span className="fw-bold">Endereço: </span>
                                {[
                                impressaoAutoInfracao?.enderecoInfrator?.logradouro,
                                impressaoAutoInfracao?.enderecoInfrator?.numero,
                                impressaoAutoInfracao?.enderecoInfrator?.complemento,
                                impressaoAutoInfracao?.enderecoInfrator?.bairro,
                                impressaoAutoInfracao?.enderecoInfrator?.cep ? mascaras.cepMask(impressaoAutoInfracao.enderecoInfrator.cep) : null
                                ]
                                .filter(Boolean) 
                                .join(', ')
                                }.
                            </p>
                        </div>

                    </div>
                </div>

                <div className="py-2 mb-2"> 
                    <h5
                        style={{ color: "#fff" }}
                        className='p-2 rounded-3 bg-gradient bg-primary d-flex justify-content-between align-items-center'
                    >
                        <span><FontAwesomeIcon icon={faFileAlt} className={"me-3"} />Dados Adicionais</span>
                    </h5>
                    <div className='row'> 
                        <div className='col-lg-6'>
                            <p>
                                <span className="fw-bold">Tipo de Notificação: </span>{" "}
                                {impressaoAutoInfracao?.tipoOcorrencia}
                            </p>
                        </div> 
                        <div className='col-lg-12'>
                            <p>
                                <span className="fw-bold">Fato constitutivo: </span> 
                                {impressaoAutoInfracao?.fatoConstitutivo}
                            </p>
                        </div>
                        <div className='col-lg-12'>
                            <p>
                                <span className="fw-bold">Preceitos legais: </span> {impressaoAutoInfracao?.preceitosLegais}
                            </p>
                        </div>
                        <div className='col-lg-6'>
                            <p>
                                <span className="fw-bold">Valor: </span> 
                                {impressaoAutoInfracao?.valorMulta}
                            </p>
                        </div>
                        <div className='col-lg-6'>
                            <p>
                                <span className="fw-bold">Imposição de multas: </span> 
                                {impressaoAutoInfracao?.valorImposicaoMulta}
                            </p>
                        </div>
                        <div className='col-lg-12'>
                            <p>
                                <span className="fw-bold"> Observações: </span>O infrator
                                fica cientificado que tem o prazo estabelecido por esta lei
                                para aparesentação de defesa ou pagamento, sob pena de ser
                                confirmada a penalidade importa e inscrita a multa como
                                dîvida ativa para ser cobrado executivamente.
                            </p>
                        </div>
                    </div>
                
                </div>

                <div className="py-2 mb-2 avoid-break"> 
                    <h5
                        style={{ color: "#fff" }}
                        className='p-2 rounded-3 bg-gradient bg-primary d-flex justify-content-between align-items-center'
                    >
                        <span><FontAwesomeIcon icon={faPencilAlt} className={"me-3"} />Assinaturas</span>
                    </h5>
                    <div className="mt-3 text-secondary d-flex align-items-center justify-content-center gap-5">
                        <div className="d-flex align-items-center justify-content-center flex-column">
                        <p>
                            <span className="fw-bold">Recebida em:</span> ___/___/___
                        </p>
                        <p
                            className="mt-4"
                            style={{
                            width: "190px",
                            borderBottom: "1px solid #ccc",
                            backgroundColor: "red",
                            }}
                        ></p>
                        <p className="fw-bold">Infrator</p>
                        </div>
                    </div>
                </div>

                <div className="py-2 mb-2 avoid-break">
                    <h5
                        style={{ color: "#fff" }}
                        className='p-2 rounded-3 bg-gradient bg-primary d-flex justify-content-between align-items-center'
                    >
                        <span><FontAwesomeIcon icon={faMapMarked} className={"me-3"} />Mapa</span>
                    </h5>
                    <div className="mx-2 mb-3 p-0" style={{ height: "250px" }}>
                        
                        {impressaoAutoInfracao &&
                            impressaoAutoInfracao?.enderecoAutoInfracao &&
                            impressaoAutoInfracao?.enderecoAutoInfracao?.latitude &&
                            impressaoAutoInfracao?.enderecoAutoInfracao?.longitude && (
                            <CustomizedMap
                                positionCenter={true}
                                addNewMarker={false}
                                markers={[{ coordenadas: { lat: impressaoAutoInfracao.enderecoAutoInfracao.latitude, lng: impressaoAutoInfracao.enderecoAutoInfracao.longitude } }]}
                                position={{
                                    lat: impressaoAutoInfracao.enderecoAutoInfracao.latitude,
                                    lng: impressaoAutoInfracao.enderecoAutoInfracao.longitude
                                }}
                                setPosition={() => {}}
                                setPointSelected={() => {}}
                                zoom={18}
                             /> 
                        )}

                           
                    </div>
                </div>

                <div className="py-2 mb-2 avoid-break"> 
                    <h5
                        style={{ color: "#fff" }}
                        className='p-2 rounded-3 bg-gradient bg-primary d-flex justify-content-between align-items-center'
                    >
                        <span><FontAwesomeIcon icon={faImage} className={"me-3"} />Imagens da fiscalização</span>
                    </h5>

                    {impressaoAutoInfracao?.imagensFiscalizacao?.length > 0 ? (
                        impressaoAutoInfracao.imagensFiscalizacao.map((img, index) => (
                            <div
                                key={index}
                                className="row mx-2 mb-3 p-0 d-flex align-items-center justify-content-center"
                                style={{ minHeight: "350px" }}
                            >
                                <div className="col-lg-12 d-flex align-items-center justify-content-center">
                                    <a
                                        href={img}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <img
                                            style={{ maxHeight: "400px", width: "100%" }}
                                            src={img}
                                            alt={`Imagem da fiscalização ${index + 1}`}
                                        />
                                    </a>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center text-muted">Nenhuma imagem</div>
                    )}
                </div>
            </div>
        </div>
    </MainCard>
  )
}
